import type {Post} from '@mattermost/types/posts';
import {getConfig} from 'mattermost-redux/selectors/entities/general';
import Constants from 'utils/constants';
import {fromAutoResponder, isFromBot, isFromWebhook} from 'utils/post_utils';
import {type GlobalState} from 'types/store';

export function getPostOverrideUsername(state: GlobalState, post?: Post) {
    if (!post || !isFromWebhook(post) || fromAutoResponder(post)) {
        return;
    }

    const config = getConfig(state);
    const usernameOverride = config.EnablePostUsernameOverride === 'true' ? post.props?.override_username : undefined;

    if (usernameOverride) {
        return usernameOverride;
    }

    if (isFromBot(post)) {
        return;
    }

    return Constants.DEFAULT_WEBHOOK_USERNAME;
}
